<template>
  <div class="archive-modal">
    <div class="archive-modal__overlay" @click="closeArchiveNotificationModal"></div>
    <div class="archive-modal__bg">
      <div class="archive-modal__body">
        <div class="archive-modal__title">
          Archive alert
        </div>
        <icon-base class="archive-modal__close" @click.native="closeArchiveNotificationModal" red>
          <icon-cross/>
        </icon-base>
        <div class="archive-modal__body-wrap">
          <div class="archive-modal__description">
            Do you really want to archive this alert? It will not notify you about currencies any more.
          </div>
          <button-el :disabled="disable" type="button" @click="closeArchiveNotificationModal" black large left class="cancel-btn">
            Cancel
            <icon-base slot="icon" black>
              <icon-cross left />
            </icon-base>
          </button-el>
          <button-el :disabled="disable" @click="archieveAlert" red large left class="confirm-btn">Confirm
            <icon-base red>
              <icon-check />
            </icon-base>
          </button-el>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { IconCross, IconCheck } from 'Icons';

export default {
  props: {
    disable: Boolean,
  },
  components: {
    IconCross,
    IconCheck,
  },
  methods: {
    ...mapActions('platformNotifications', [
      'closeArchiveNotificationModal',
      'archieveAlert',
    ]),
  },
};
</script>


<style lang="scss" scoped>
.archive-modal {
  $side-padding: 30px;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10000;
  &__overlay {
    width: 100%;
    height: 100%;
    background: $black-color5;
    z-index: 1;
    position: relative;
  }
  &__bg {
    overflow-y: auto;
    width: 100%;
    height: 100%;
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
  }
  &__title {
    @include font(24px, $black-color1, 500);
    border-bottom: 1px solid $white-color5;
    padding: 29px 31px 32px;
    margin-bottom: 32px;
  }
  &__description {
    margin-bottom: 33px;
    line-height: 23px;
  }
  &__close {
    cursor: pointer;
    position: absolute;
    right: 29px;
    top: 28px;
  }
  &__body {
    border-radius: 5px;
    margin: auto;
    background: $white-color2;
    position: relative;
    max-width: 440px;
    width: 100%;
    z-index: 2;
    padding-bottom: 45px;
  }
  &__body-wrap {
    padding: 0 $side-padding;
  }
}
.cancel-btn {
  padding: 10.5px 12px 10.5px 19px;
  margin-left: 1px;
}
.confirm-btn {
  margin-left: 15px;
  padding: 10.5px 8px 10.5px 19px;
}
</style>



// WEBPACK FOOTER //
// src/components/PlatformNotifications/ArchiveNotificationModal.vue